<div class="modal-header">
  <h3 class="modal-title" i18n="@@BANK-TRANSFER-001">Transfer Money</h3>
  <button type="button" [disabled]="refreshingBalance" class="close" aria-label="Close" (click)="activeModal.close(balance)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <inline-msg [inlineMsg]="componentMessage"></inline-msg>
  <div class="col-12 text-center" *ngIf="refreshingBalance">
    <fa-icon [icon]="['fas', 'sync']" [spin]="true"></fa-icon>
  </div>
  <div class="row amount-line" *ngIf="!refreshingBalance && bank">
    <div class="user-balance col-12 col-sm-6 col-md-6 col-lg-6">
      <h4 i18n="@@BANK-TRANSFER-002">Your balance:</h4>
      <span class="total-earnings">{{balance | currency:'USD':'symbol'}}</span>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-6">
      <label i18n="@@BANK-TRANSFER-003">Amount to transfer:</label>
      <price-field
        [decimals] = "2"
        [symbol] = "'$'"
        [max] = "amountToTransfer"
        [min] = "0"
        [disabled]="amountToTransfer <= 0"
        [allownull] = "false"
        i18n-placeholder="@@BANK-TRANSFER-004"
        placeholder = "'Write the amount here'"
        (validPriceEvent) = "priceValid($event)">
      </price-field>
      <label class="notd-fee">
        <span>+ {{fee | currency:'USD':'symbol'}}</span>
        <span i18n="@@BANK-TRANSFER-005">fee:</span>
        <span>{{(amountToTransferEdited + fee) | currency:'USD':'symbol'}}</span>
      </label>
    </div>
  </div>

  <div class="row transfer-section">
    <div class="col-6 col-sm-6 col-md-6 col-lg-5 bank-mode-switch">
      <h5 i18n="@@BANK-TRANSFER-006">Documentation</h5>
    </div>
  </div>
  <div class="row notd-user-docs-wrapper">
    <div class="notd-user-docs">
      <notd-tax-doc></notd-tax-doc>
      <notd-id-doc></notd-id-doc>
    </div>
  </div>
  <div class="row transfer-section">
    <div class="col-6 col-sm-6 col-md-6 col-lg-5 bank-mode-switch">
      <h5 i18n="@@BANK-TRANSFER-007">Legal and Bank information</h5>
    </div>
    <div class="col-6 col-sm-6 col-md-6 col-lg-7 text-right bank-mode-switch">
      <span class="link" [hidden]="editingBank || noBank" (click)="changeBank()" i18n="@@BANK-TRANSFER-008">change information</span>
    </div>
  </div>
  <div class="row no-bank-info" [hidden]="!noBank">
    <p class="col-12 text-center" i18n="@@BANK-TRANSFER-010">
        You have no bank information entered. Please add your account information to initiate a transfer.
    </p>
    <div class="col-12 text-center">
      <button type="button" class="btn notd-primary-btn" (click)="addBank()" i18n="@@BANK-TRANSFER-011">Add Bank</button>
    </div>
  </div>
  <div class="row" [hidden]="editingBank || noBank">
    <div class="col-12 col-sm-6 col-md-6 col-lg-6 bank-address">
      <div class="col-12 text-center" [hidden]="!refreshingLegalInfo">
        <fa-icon [icon]="['fas', 'sync']" [spin]="true"></fa-icon>
      </div>
      <h3>Contact Information</h3>
      <p>{{legalInfo?.fullLegalName}}</p>
      <p>{{legalInfo?.legalAddress?.line1}}</p>
      <p>{{legalInfo?.legalAddress?.line2}}</p>
      <p>{{legalInfo?.legalAddress?.city}} {{legalInfo?.legalAddress?.postalCode}}</p>
      <p>{{legalInfo?.legalAddress?.region}}</p>
      <p>{{legalInfo?.legalAddress?.countryName}}</p>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-6 bank-info">
      <div class="col-12 text-center" [hidden]="!refreshingBank">
        <fa-icon [icon]="['fas', 'sync']" [spin]="true"></fa-icon>
      </div>
      <h3>Bank Information</h3>
      <p class="strong">{{bank?.name}}</p>
      <p>
        <span class="strong" i18n="@@BANK-TRANSFER-012">Account holder</span>
        <span> {{bank?.accountHolder}}</span>
      </p>
      <p>
        <span class="strong" i18n="@@BANK-TRANSFER-013">Account number</span>
        <span> {{bank?.accNumLast4 ? bank && '****' + bank?.accNumLast4 : ''}}</span>
      </p>
      <p *ngIf="bank?.transferMethod === enumTransferMethod.ACH">
        <span class="strong" i18n="@@BANK-TRANSFER-014">Routing number</span>
        <span> {{bank?.routingNumber}}</span>
      </p>
      <p *ngIf="bank?.transferMethod === enumTransferMethod.IBAN && bank?.iban">
        <span class="strong" i18n="@@BANK-TRANSFER-015">Iban</span>
        <span> {{bank?.iban}}</span>
      </p>
      <p *ngIf="bank?.transferMethod === enumTransferMethod.IBAN && bank?.swift">
        <span class="strong" i18n="@@BANK-TRANSFER-016">Swift</span>
        <span>{{bank?.swift}}</span>
      </p>
    </div>
  </div>
  <div class="row" [hidden]="!editingBank">
    <div class="col-12">
      <notd-legal-info #legalInfoComponent (legalInfoEmitter)="legalInfoEvent($event)"></notd-legal-info>
      <hr>
      <notd-banking-form #bankingComponent (bankEmitter)="bankingEvent($event)"></notd-banking-form>
    </div>
    <div class="form-buttons">
      <button type="button"
              class="btn notd-primary-btn"
              (click)="saveBankInfoForm()">Save bank information</button>
      <button type="button"
              class="btn notd-secondary-btn"
              (click)="changeBank()">Close</button>
    </div>
  </div>
  <inline-msg [inlineMsg]="componentMessage"></inline-msg>
</div>

<div class="modal-footer">
  <button type="button"
          class="btn notd-primary-btn"
          [disabled]="!amountValid || editingBank || !bank || !legalInfo || saving || !legalInfoForm?.valid || !bankForm?.valid"
          (click)="transferMoney()"
          i18n="@@BANK-TRANSFER-001">Transfer Money</button>
</div>
